import script from "./comGroupDetailOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./comGroupDetailOverview.vue?vue&type=script&setup=true&lang=js"

import "./comGroupDetailOverview.vue?vue&type=style&index=0&id=27638e3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27638e3e"]])

export default __exports__